export default __webpack_public_path__ + "static/media/biz-mobile1.42f3a487.png";